import React from 'react';
import PropTypes from 'prop-types';
import { useHistory, useParams } from 'react-router-dom';
import { Paper, CircularProgress, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';
import Dashboard3Drawers from '../dashboard-3-drawers/Dashboard3Drawers';
import MyForm from '../../form/MyForm';
import prepareFormikInitialValues from '../../form/form-helpers';
import { AppState } from '../../state/MyStateProvider';
import { crudFormFieldsPropTypes, crudFormValidationSchemaPropTypes } from './crud-prop-types';
import pageUtilsPropTypes from '../page-prop-types';
import { drawerRoutesPropTypes } from '../dashboard-3-drawers/d3d-prop-types';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
  },
  onAppBar: {
    color: theme.palette.common.white,
  },
}));

const CRUDFormPage = (props) => {
  const {
    fields,
    formType,
    inputRefs,
    validationSchema,
    pageUtils,
    Repository,
    routes,
    isLoading,
    labelIds,
    init,
    drawerRoutes,
    AuthenticationRepository,
    applicationName,
    logo,
    icons,
  } = props;
  const { id } = useParams();
  const history = useHistory();
  const { state } = React.useContext(AppState);
  const [repo] = React.useState(new Repository(state));

  const [formFields, setFormFields] = React.useState(fields);
  const [initialValues, setInitialValues] = React.useState(null);
  const [isReady, setIsReady] = React.useState(false);
  const [isCreate, setIsCreate] = React.useState(true);

  const inputRef1 = React.useRef(null);
  const inputRef2 = React.useRef(null);
  const inputRef3 = React.useRef(null);
  const inputRef4 = React.useRef(null);
  const inputRef5 = React.useRef(null);
  const inputRef6 = React.useRef(null);
  const inputRef7 = React.useRef(null);
  const inputRef8 = React.useRef(null);
  const inputRef9 = React.useRef(null);
  const inputRef10 = React.useRef(null);
  const inputRef11 = React.useRef(null);
  const inputRef12 = React.useRef(null);
  const inputRef13 = React.useRef(null);
  const inputRef14 = React.useRef(null);

  const realInputRefs = {};
  inputRefs.map((input, index) => {
    switch (index) {
      case 0:
        realInputRefs[input.name] = inputRef1;
        break;
      case 1:
        realInputRefs[input.name] = inputRef2;
        break;
      case 2:
        realInputRefs[input.name] = inputRef3;
        break;
      case 3:
        realInputRefs[input.name] = inputRef4;
        break;
      case 4:
        realInputRefs[input.name] = inputRef5;
        break;
      case 5:
        realInputRefs[input.name] = inputRef6;
        break;
      case 6:
        realInputRefs[input.name] = inputRef7;
        break;
      case 7:
        realInputRefs[input.name] = inputRef8;
        break;
      case 8:
        realInputRefs[input.name] = inputRef9;
        break;
      case 9:
        realInputRefs[input.name] = inputRef10;
        break;
      case 10:
        realInputRefs[input.name] = inputRef11;
        break;
      case 11:
        realInputRefs[input.name] = inputRef12;
        break;
      case 12:
        realInputRefs[input.name] = inputRef13;
        break;
      case 13:
        realInputRefs[input.name] = inputRef14;
        break;
      default:
        break;
    }
    return null;
  });

  const loadInit = (
    j,
    payloads,
    iValues = null,
    create = true,
  ) => {
    const i = init[j];
    pageUtils.loadSomething(
      () => i.load(),
      (payload) => {
        payloads.push(payload);
        // i.onLoadSuccess(payload);
        if (j === init.length - 1) {
          setFormFields(i.setFormFields(fields, payloads));
          setInitialValues(prepareFormikInitialValues(iValues, create, fields));
          setIsReady(true);
        } else {
          loadInit(j + 1, payloads, iValues, create);
        }
      },
      i.successMessage,
      i.errorMessage,
      i.shouldShowSuccessSnackbar,
      i.setIsLoadingFalseOnSuccess,
    );
  };

  React.useEffect(() => {
    // If `id` exists, form is editing data.
    if (id) {
      if (init.length > 0) {
        setIsReady(false);
        setIsCreate(false);
        const payloads = [];
        pageUtils.loadSomething(
          () => repo.getById(id),
          (dataPayload) => {
            loadInit(
              0,
              payloads,
              dataPayload,
              false,
            );
          },
          '',
          labelIds.errorLoad,
          false,
        );
        // for (let j = 0; j < init.length; j += 1) {
        //   const i = init[j];
        //   pageUtils.loadSomething(
        //     () => i.load(),
        //     (payload) => {
        //       payloads.push(payload);
        //       // i.onLoadSuccess(payload);
        //       if (j === init.length - 1) {
        //         setFormFields(i.setFormFields(fields, payloads));
        //       }
        //     },
        //     i.successMessage,
        //     i.errorMessage,
        //     i.shouldShowSuccessSnackbar,
        //     i.setIsLoadingFalseOnSuccess,
        //   );
        // }
      } else {
        setIsCreate(false);
        pageUtils.loadSomething(
          () => repo.getById(id),
          (payload) => {
            setInitialValues(prepareFormikInitialValues(payload, false, fields));
            setIsReady(true);
          },
          '',
          labelIds.errorLoad,
          false,
        );
      }
    } else {
      // If `id` doesn't exist, form is creating data.
      // eslint-disable-next-line no-lonely-if
      if (init.length > 0) {
        setIsReady(false);
        const payloads = [];
        loadInit(
          0,
          payloads,
        );
      } else {
        setInitialValues(prepareFormikInitialValues(null, true, fields));
        setIsReady(true);
      }
    }

    return () => {
      // cleanup
    };
    // eslint-disable-next-line
  }, [repo, pageUtils, fields, id, labelIds, init]);

  const handleCreate = (data) => {
    pageUtils.loadSomething(
      () => repo.create(data),
      () => { history.push(routes.index.path); },
      null,
      labelIds.errorCreate,
      false,
      false,
    );
  };

  const handleEdit = (data) => {
    pageUtils.loadSomething(
      () => repo.updateById(id, data),
      () => { history.push(routes.index.path); },
      null,
      labelIds.errorUpdate,
      false,
      false,
    );
  };
  const formikRef = React.useRef();

  const classes = useStyles();
  return (
    <Dashboard3Drawers
      AuthenticationRepository={AuthenticationRepository}
      routes={drawerRoutes}
      applicationName={applicationName}
      logo={logo}
      icons={icons}
      titleId={isCreate ? routes.create.titleId : routes.edit.titleId}
      useBackButton
      backButtonAction={(
        <Button
          variant="text"
          className={classes.onAppBar}
          onClick={() => formikRef.current.handleSubmit()}
          disabled={isLoading}
          startIcon={isLoading ? <CircularProgress color="secondary" size={20} /> : ''}
        >
          <FormattedMessage id="seed.button.save" />
        </Button>
      )}
      breadcrumbs={[
        {
          id: 'index',
          href: routes.index.path,
          titleId: routes.index.titleId,
        },
        {
          id: 'create_edit',
          titleId: isCreate ? routes.create.titleId : routes.edit.titleId,
        },
      ]}
    >
      <Paper className={classes.paper}>
        {
          !isReady ? <CircularProgress />
            : (
              <MyForm
                ref={formikRef}
                onSubmit={(values) => (isCreate ? handleCreate(values) : handleEdit(values))}
                fields={formFields}
                validationSchema={validationSchema}
                disabled={isLoading}
                repository={repo}

                formType={formType}
                isHideOnMobile
                pageUtils={pageUtils}
                isCreate={isCreate}
                formikRef={formikRef}

                initialValues={initialValues}
                defaultValues={initialValues}

                submitButtonLabelId="seed.button.save"
                inputRefs={realInputRefs}

                icons={icons}
              />
            )
        }
      </Paper>
    </Dashboard3Drawers>
  );
};

CRUDFormPage.propTypes = {
  fields: crudFormFieldsPropTypes.isRequired,
  validationSchema: crudFormValidationSchemaPropTypes.isRequired,
  pageUtils: pageUtilsPropTypes.isRequired,
  routes: PropTypes.shape({
    index: PropTypes.shape({
      path: PropTypes.string,
      titleId: PropTypes.string,
    }),
    create: PropTypes.shape({
      titleId: PropTypes.string,
    }),
    edit: PropTypes.shape({
      titleId: PropTypes.string,
    }),
  }).isRequired,
  labelIds: PropTypes.shape({
    errorLoad: PropTypes.string.isRequired,
    errorCreate: PropTypes.string,
    errorUpdate: PropTypes.string,
  }).isRequired,
  Repository: PropTypes.func.isRequired,

  isLoading: PropTypes.bool,
  formType: PropTypes.oneOf(['controlled', 'uncontrolled']),
  init: PropTypes.arrayOf(PropTypes.any),
  inputRefs: PropTypes.array,
  AuthenticationRepository: PropTypes.func.isRequired,
  drawerRoutes: drawerRoutesPropTypes.isRequired,
  applicationName: PropTypes.string.isRequired,
  logo: PropTypes.string.isRequired,
  icons: PropTypes.objectOf(PropTypes.object).isRequired,
};

CRUDFormPage.defaultProps = {
  isLoading: false,
  formType: 'controlled',
  init: [],
  inputRefs: [],
};

export default CRUDFormPage;
